module.exports = __webpack_public_path__ + "img/n-h-banner1.b658ee69.png";